import Api from "@/helpers/api.js";
import {createCapacityFilter, processCapacity} from "@/store/payloadHelper.js";

export default {
	save({commit}, payload) {
		return new Promise((resolve, reject) => {
			Api.post("/capacity", payload)
				.then((res) => {
					commit("ADD_CAPACITY", Object.assign(payload, {id: res.data.id}));
					resolve(res);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	findAll({commit}) {
		return new Promise((resolve, reject) => {
			Api.get("/capacity")
				.then((res) => {
					commit("SET_CAPACITY", res.data);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	findById({commit}, id) {
		return new Promise((resolve, reject) => {
			Api.get(`/capacity/${id}`)
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	update({commit}, payload) {
		return new Promise((resolve, reject) => {
			Api.put(`/capacity/${payload.id}`, payload.params)
				.then((res) => {
					commit("UPDATE_CAPACITY", res.data);
					resolve(res);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	deleteById({commit}, id) {
		return new Promise((resolve, reject) => {
			Api.delete(`/capacity/${id}`)
				.then((res) => {
					resolve(res);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	findCapacityFilter({commit}, data) {
		return new Promise((resolve, reject) => {
			const payload = createCapacityFilter(data);
			Api.post("/capacity/filter", payload)
				.then((res) => {
					const records = res.data.records.map(processCapacity);
					if (data.assigned) {
						commit("SET_ASSIGNED_CAPACITY", records);
					} else {
						commit("SET_CAPACITY", records);
					}
					resolve(res.data);
				})
				.catch((err) => reject(err));
		});
	},
	currentCapacitySelected({commit}, capacity) {
		return new Promise((resolve, reject) => {
			commit("SELECTED_CAPACITY", capacity);
			resolve(capacity);
		});
	},
};
